import { Routes } from '@angular/router';

export const paymentGatewayRoutes: Routes = [
  {
    data: { key: 'banco-de-chile-boton-de-pago-payment-result' },
    loadComponent: () => import('./banco-de-chile-boton-de-pago-payment-result/banco-de-chile-boton-de-pago-payment-result.page').then((m) => m.BancoDeChileBotonDePagoPaymentResultPage),
    path: 'bchbdp-payment-result',
  },
  {
    data: { key: 'bci-pague-directo-payment-result' },
    loadComponent: () => import('./bci-pague-directo-payment-result/bci-pague-directo-payment-result.page').then((m) => m.BciPagueDirectoPaymentResultPage),
    path: ':chargeIntentPublicId/bpd-payment-result/:depositIntentPublicId',
  },
  {
    data: { key: 'santander-boton-de-pago-payment-result' },
    loadComponent: () => import('./santander-boton-de-pago-payment-result/santander-boton-de-pago-payment-result.page').then((m) => m.SantanderBotonDePagoPaymentResultPage),
    path: 'sbdp-payment-result',
  },
  {
    data: { key: 'transbank-webpay-plus-payment-result' },
    loadComponent: () => import('./transbank-webpay-plus-payment-result/transbank-webpay-plus-payment-result.page').then((m) => m.TransbankWebpayPlusPaymentResultPage),
    path: ':chargeIntentPublicId/twp-payment-result/:depositIntentPublicId',
  },
  {
    data: { key: 'checkout' },
    loadComponent: () => import('./checkout/checkout.page').then((m) => m.CheckoutPage),
    path: ':chargeIntentPublicId',
  },
  {
    data: { key: 'checkout' },
    loadComponent: () => import('./checkout/checkout.page').then((m) => m.CheckoutPage),
    path: '**',
  },
];
